import React from 'react';
import { Share } from './Share';
import ModalTemplate from '../../ModalTemplate';

const ShareModal = ({
	title,
	shareUrl,
	isOpen,
	onClose,
	hashtag,
}: {
	hashtag?: string;
	title?: string;
	shareUrl: string;
	isOpen: boolean;
	onClose: () => void;
}) => {
	return (
		<ModalTemplate
			title=""
			marginX={2}
			isOpen={isOpen}
			bgColor="white"
			maxWidth="343px"
			showCloseButton={true}
			showCloseButtonIcon={true}
			modalContentProps={{ shadow: 'none', p: '0px' }}
			modalOverlayProps={{ bg: 'rgba(1, 10, 27, 0.80)' }}
			onClose={() => onClose()}
		>
			<Share linkedInUrl={shareUrl} facebookUrl={shareUrl} twitterUrl={shareUrl} title={title || ''} hashtag={hashtag || ''} screen_name={''} />
		</ModalTemplate>
	);
};

export default ShareModal;
